
import request from '@/utils/request'


export function getPageList(data) {
  return request({
    url: 'RunPostureShoes/getPageList',
    method: 'post',
    data
  })
}

export function save(data) {
  return request({
    url: 'RunPostureShoes/save',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: 'RunPostureShoes/delete',
    method: 'post',
    data
  })
}
